import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import BinaModal from '../ReactModal';
import { getGoogleApiKey } from '../../utils/helpers/common';

const LoadingContainer = () => <div />;

const MapModal = memo(({ isOpen, hide, lng, lat, google }) => {
  return (
    <BinaModal
      isOpen={isOpen}
      onRequestClose={hide}
      modalId="map"
      overlayClassName="modal__overlay--map"
      contentClassName="modal__content--map"
    >
      <div className="map-container">
        <Map google={google} zoom={14} initialCenter={{ lat, lng }}>
          <Marker
            position={{
              lat,
              lng
            }}
          />
        </Map>
        <span
          className="map__close-btn"
          onClick={hide}
          onKeyPress={hide}
          role="button"
          tabIndex="-1"
        >
          ×
        </span>
      </div>
    </BinaModal>
  );
});

MapModal.displayName = `MapModal`;

MapModal.propTypes = {
  isOpen: PropTypes.bool,
  hide: PropTypes.func,
  lat: PropTypes.number,
  lng: PropTypes.number,
  google: PropTypes.object
};

export default GoogleApiWrapper(props => ({
  apiKey: getGoogleApiKey(),
  LoadingContainer,
  language: props.language
}))(MapModal);
